import { render, staticRenderFns } from "./ziduanConfigDialog.vue?vue&type=template&id=1e90b9cb&"
import script from "./ziduanConfigDialog.vue?vue&type=script&lang=ts&"
export * from "./ziduanConfigDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ziduanConfigDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports